import {memo} from 'react'

import {formatDurationWithMilliseconds} from '../../../../../../utils/dateTimeUtils'
import RowGroup from '../../../../../common/Grid/RowGroup'
import ListItem from '../../../../../common/ListItem/ListItem'
import type {TestScopesKey, TestScopeType} from '../../../../../packages/Tests/Tests.types'

import TestScopeName from './TestScopeName/TestScopeName'

import styles from './TestScope.css'

type Props = {
  scopeKey: TestScopesKey
  scope: TestScopeType
  withCountersColumns?: boolean
}

function TestScope({scopeKey, scope, withCountersColumns}: Props) {
  const {
    duration = 0,
    all,
    success,
    failed,
    muted,
    ignored,
  } = scope.testOccurrences?.testCounters ?? {}
  const formatedDuration = formatDurationWithMilliseconds(duration)
  return (
    <RowGroup>
      <ListItem
        className={styles.testScope}
        rowClassName={styles.testScopeRow}
        highlightHover
        hideBorders
      >
        <div className={styles.nameColumn}>
          <TestScopeName scopeKey={scopeKey} scope={scope} />
        </div>
        <div className={styles.durationColumn}>{formatedDuration}</div>
        <div className={styles.countColumn} title="Tests">
          {all}
        </div>
        {withCountersColumns ? (
          <>
            <div className={styles.successColumn} title="Success">
              {success || null}
            </div>
            <div className={styles.failureColumn} title="Failure">
              {failed || null}
            </div>
            <div className={styles.mutedColumn} title="Muted">
              {muted || null}
            </div>
            <div className={styles.ignoredColumn} title="Ignored">
              {ignored || null}
            </div>
          </>
        ) : null}
      </ListItem>
    </RowGroup>
  )
}

export default memo<Props>(TestScope)
